define('v3/Pages/SchoolReport/ViewModels/SchoolReport.ViewModel',[
	'module',
	'knockout',
	'lodash',
	'jquery',
	'env',
	'v3/Common/Models/enums',
	'v3/Pages/SchoolReport/Services/SchoolReport.Service',
	'v3/Common/Services/boundaryPercentileService',
	'safe-mode',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Mask.Binding',
	'v3/Common/Bindings/Ellipsis.Binding',
	'v3/Common/Bindings/Progress.Binding'
],
function (module, ko, _, $, env, enums, schoolReportService, boundaryPercentileService, safeModeService) {
	function SchoolReportViewModel () {
		var self = this;

		self.hasData = ko.observable(false);
		self.loadingSubjects = ko.observable(true);

		self.isLoading = ko.observable(true);
		self.selectedPeriod = ko.observable(enums.semesterPeriod.year);

		self.classes = ko.observableArray();
		self.subjects = ko.observableArray();
		self.growthScores = ko.observableArray([]);

		self.subjectDetails = ko.observableArray([]);
		self.subjectDetailsActive = ko.observable(null);
		self.subjectDetailsActiveClass = ko.observable(null);
		safeModeService.safeMode.setSubjectId(null);
		safeModeService.safeMode.setGrade(null);
		safeModeService.safeMode.setCourseId(null);
		safeModeService.safeMode.setSectionId(null);
		safeModeService.safeMode.setLessonId(null);

		self.goToCheckPage = function (vm) {
			var url = '/V4/' + vm.classId + '/' + vm.subject.subjectId + '/all/review/class/all';
			window.location.href = url;
		};

		var loadOverviewData = function () {
			self.growthScores([]);

			var period = self.selectedPeriod();

			var subjectWithClassIdsModels =
				_(self.subjects())
					.filter(function (subject) {
						return subject.classesWithSubjectGroup && subject.classesWithSubjectGroup.length;
					})
					.map(function (subject) {
						return {
							subjectId: subject.subjectId,
							classIds: subject.classesWithSubjectGroup.map(function (cls) {
								return cls.classId;
							})
						};
					})
					.value();

			return schoolReportService.getGrowthsOnClassesPerSubjects(period, subjectWithClassIdsModels)
				.done(function (growthScores) {
					self.growthScores(growthScores);
				});
		};

		var loadDetailsData = function () {
			self.subjectDetails([]);

			var period = self.selectedPeriod();
			var subject = self.subjectDetailsActive();

			var classIds = subject.classesWithSubjectGroup.map(function (cls) {
				return cls.classId;
			});

			return $.when(
				schoolReportService.getSchoolProgress(subject.subjectCategory, period),
				schoolReportService.getAbilitiesOnClassesOnSubject(period, { subjectId: subject.subjectId, classIds: classIds })
			)
				.then(function (schoolProgress, subjectBoundaryPercentiles) {
					var fallback = { progress: {} };
					var highestExercises = (_.maxBy(schoolProgress, 'progress.numberOfExercises') || fallback).progress.numberOfExercises || 0;
					var highestAdaptive = (_.maxBy(schoolProgress, 'progress.percentageAdaptive') || fallback).progress.percentageAdaptive || 0;
					var highestWorkingset = (_.maxBy(schoolProgress, 'progress.numberOfExercisesInWorkingSets') || fallback).progress.numberOfExercisesInWorkingSets || 0;
					var highestInstruction = (_.maxBy(schoolProgress, 'progress.numberOfInstructionsSets') || fallback).progress.numberOfInstructionsSets || 0;

					self.subjectDetails(
						_.map(self.classes(), function (data) {
							var classWithSubjectGroup = _.find(subject.classesWithSubjectGroup, ['classId', data.classId]);
							data.noData = _.isNil(classWithSubjectGroup);

							var abilityPercentile = (_.find(subjectBoundaryPercentiles, ['classId', data.classId]) || { percentile: null });
							var classData = (_.find(schoolProgress, ['classId', data.classId]) || fallback);
							var progress = classData.progress;
							var stage = classData.stage;

							data.subject = subject;
							data.subjectGroupId = data.noData ? null : classWithSubjectGroup.subjectGroupId;
							data.ability = boundaryPercentileService
								.getLegendTypeByScore(abilityPercentile.score, abilityPercentile.percentile) ||
								{ percentile: null };
							data.wayofworking = { value: stage || 0 };

							data.exercises = { value: progress.numberOfExercises || 0 };
							data.exercises.percentage = (data.exercises.value / highestExercises) * 100 || 0;
							data.exercises.highest = highestExercises;

							data.adaptive = { value: progress.percentageAdaptive || 0 };
							data.adaptive.percentage = (data.adaptive.value / highestAdaptive) * 100 || 0;
							data.adaptive.highest = highestAdaptive;

							data.workingset = { value: progress.numberOfExercisesInWorkingSets || 0 };
							data.workingset.percentage = (data.workingset.value / highestWorkingset) * 100 || 0;
							data.workingset.highest = highestWorkingset;

							data.extraInstructions = { value: progress.numberOfInstructionsSets || 0 };
							data.extraInstructions.percentage = (data.extraInstructions.value / highestInstruction) * 100 || 0;
							data.extraInstructions.highest = highestInstruction;

							return data;
						})
					);
				});
		};

		var loadData = function () {
			schoolReportService.getSubjectsAndClasses()
				.done(function (data) {
					if (!data.subjects || data.subjects.length === 0) {
						self.loadingSubjects(false);
						return;
					}

					self.classes(data.classes);

					self.subjects(data.subjects.map(function (subject) {
						return {
							subjectId: subject.id,
							subjectCategory: subject.subjectCategory,
							subjectName: subject.name,
							iconName: subject.iconName + 'Colored',
							classesWithSubjectGroup: subject.classes
						};
					}));

					self.hasData(true);

					self.selectedPeriod.subscribe(function () {
						self.isLoading(true);

						var deferred =
							self.subjectDetailsActiveClass()
								? $.when(loadDetailsData(), loadOverviewData())
								: loadOverviewData();

						deferred.always(function () {
							self.isLoading(false);
						});
					});

					loadOverviewData().done(function () {
						self.isLoading(false);
						self.loadingSubjects(false);
					});
				})
				.fail(function () {
					self.loadingSubjects(false);
				});
		};

		self.setSubject = function (classInfo, subject) {
			var previousClassId = self.subjectDetailsActiveClass();

			if (previousClassId === classInfo.classId) {
				self.subjectDetailsActive(null);
				self.subjectDetailsActiveClass(null);
				return;
			}

			self.subjectDetailsActive(subject);
			self.subjectDetailsActiveClass(classInfo.classId);

			if (previousClassId) {
				return;
			}

			self.isLoading(true);
			loadDetailsData().done(function () {
				self.isLoading(false);
			});
		};

		self.getGrowthDetailsForSubjectInClass = function (subjectId, classId) {
			var subject = _.find(self.growthScores(), ['subjectId', subjectId]);
			if (!subject) {
				return null;
			}

			return _.find(subject.classGrowthDetails, ['classId', classId]);
		};

		self.goToTeach = function () {
			schoolReportService.goToTeach();
		};

		self.showClassReportLink = function () {
			return true;
		};

		self.getClassReportUrl = function (classId) {
			return '/V4/' + classId + '/all/all/review';
		};

		self.getIconName = function (stage) {
			switch (stage) {
			case 1:
				return 'Lesson';
			case 2:
				return 'Plus';
			case 3:
				return 'LOPackage';
			case 4:
				return 'ExtendedInstruction';
			default:
				return '';
			}
		};

		loadData();
	}

	return SchoolReportViewModel;
});
